export interface WatchModel {
  brand: string;
  model: string;
  reference?: string;
}

export const WATCH_BRANDS = [
  'Rolex',
  'Omega',
  'Patek Philippe',
  'Audemars Piguet',
  'Cartier',
  'TAG Heuer',
  'Breitling',
  'IWC',
  'Jaeger-LeCoultre',
  'Hublot',
  'Panerai',
  'Tudor',
  'Zenith',
  'Vacheron Constantin',
  'A. Lange & Söhne',
  'Richard Mille',
  'Chopard',
  'Bulgari',
  'Hermès',
  'Longines',
  'Tissot',
  'Seiko',
  'Grand Seiko',
  'Casio',
  'G-Shock',
  'Blancpain',
  'Girard-Perregaux',
  'Ulysse Nardin',
  'Piaget',
  'Breguet',
  'Bell & Ross',
  'Montblanc',
  'Nomos',
  'Oris',
  'Swatch',
  'Rado',
  'Hamilton',
  'Frederique Constant',
  'Maurice Lacroix',
  'Baume & Mercier',
  'Corum',
  'Jacob & Co',
  'Franck Muller',
  'Roger Dubuis',
  'MB&F',
  'H. Moser & Cie',
] as const;

export const WATCH_MODELS: WatchModel[] = [
  // Rolex
  { brand: 'Rolex', model: 'Submariner', reference: '126610LN' },
  { brand: 'Rolex', model: 'Submariner Date', reference: '126610LV' },
  { brand: 'Rolex', model: 'Daytona', reference: '116500LN' },
  { brand: 'Rolex', model: 'GMT-Master II', reference: '126710BLNR' },
  { brand: 'Rolex', model: 'GMT-Master II Pepsi', reference: '126710BLRO' },
  { brand: 'Rolex', model: 'Datejust 41', reference: '126334' },
  { brand: 'Rolex', model: 'Datejust 36', reference: '126234' },
  { brand: 'Rolex', model: 'Day-Date 40', reference: '228235' },
  { brand: 'Rolex', model: 'Explorer', reference: '124270' },
  { brand: 'Rolex', model: 'Explorer II', reference: '226570' },
  { brand: 'Rolex', model: 'Sea-Dweller', reference: '126600' },
  { brand: 'Rolex', model: 'Deepsea', reference: '136660' },
  { brand: 'Rolex', model: 'Yacht-Master 42', reference: '226659' },
  { brand: 'Rolex', model: 'Sky-Dweller', reference: '336935' },
  { brand: 'Rolex', model: 'Air-King', reference: '126900' },
  { brand: 'Rolex', model: 'Milgauss', reference: '116400GV' },
  { brand: 'Rolex', model: 'Oyster Perpetual 41', reference: '124300' },
  { brand: 'Rolex', model: 'Oyster Perpetual 36', reference: '126000' },

  // Omega
  { brand: 'Omega', model: 'Speedmaster Moonwatch', reference: '310.30.42.50.01.001' },
  { brand: 'Omega', model: 'Speedmaster Racing', reference: '329.30.44.51.04.001' },
  { brand: 'Omega', model: 'Seamaster 300M', reference: '210.30.42.20.01.001' },
  { brand: 'Omega', model: 'Seamaster Planet Ocean', reference: '215.30.44.21.01.001' },
  { brand: 'Omega', model: 'Seamaster Aqua Terra', reference: '220.10.41.21.01.001' },
  { brand: 'Omega', model: 'Constellation', reference: '131.10.39.20.02.001' },
  { brand: 'Omega', model: 'De Ville Prestige' },
  { brand: 'Omega', model: 'Seamaster Diver 300M' },

  // Patek Philippe
  { brand: 'Patek Philippe', model: 'Nautilus', reference: '5711/1A' },
  { brand: 'Patek Philippe', model: 'Nautilus Chronograph', reference: '5980/1A' },
  { brand: 'Patek Philippe', model: 'Aquanaut', reference: '5167A' },
  { brand: 'Patek Philippe', model: 'Calatrava', reference: '5227G' },
  { brand: 'Patek Philippe', model: 'Grand Complications', reference: '5270G' },
  { brand: 'Patek Philippe', model: 'Twenty~4', reference: '4910/1A' },
  { brand: 'Patek Philippe', model: 'World Time', reference: '5231J' },

  // Audemars Piguet
  { brand: 'Audemars Piguet', model: 'Royal Oak', reference: '15500ST' },
  { brand: 'Audemars Piguet', model: 'Royal Oak Chronograph', reference: '26331ST' },
  { brand: 'Audemars Piguet', model: 'Royal Oak Offshore', reference: '26470ST' },
  { brand: 'Audemars Piguet', model: 'Royal Oak Offshore Diver', reference: '15710ST' },
  { brand: 'Audemars Piguet', model: 'Code 11.59', reference: '15210CR' },

  // Cartier
  { brand: 'Cartier', model: 'Santos de Cartier', reference: 'WSSA0018' },
  { brand: 'Cartier', model: 'Tank Française', reference: 'WSTA0065' },
  { brand: 'Cartier', model: 'Tank Must', reference: 'WSTA0041' },
  { brand: 'Cartier', model: 'Panthère de Cartier', reference: 'WSPN0007' },
  { brand: 'Cartier', model: 'Ballon Bleu', reference: 'WSBB0025' },
  { brand: 'Cartier', model: 'Drive de Cartier' },

  // TAG Heuer
  { brand: 'TAG Heuer', model: 'Carrera Chronograph', reference: 'CBS2210' },
  { brand: 'TAG Heuer', model: 'Monaco', reference: 'CBL2111' },
  { brand: 'TAG Heuer', model: 'Aquaracer', reference: 'WBP201A' },
  { brand: 'TAG Heuer', model: 'Formula 1', reference: 'CAZ1010' },

  // Breitling
  { brand: 'Breitling', model: 'Navitimer', reference: 'AB0127' },
  { brand: 'Breitling', model: 'Superocean Heritage', reference: 'AB2020' },
  { brand: 'Breitling', model: 'Chronomat B01', reference: 'AB0134' },
  { brand: 'Breitling', model: 'Avenger', reference: 'A17318' },

  // IWC
  { brand: 'IWC', model: 'Portugieser Chronograph', reference: 'IW371605' },
  { brand: 'IWC', model: 'Pilot Mark XX', reference: 'IW328201' },
  { brand: 'IWC', model: 'Big Pilot', reference: 'IW501001' },
  { brand: 'IWC', model: 'Portofino Automatic', reference: 'IW356501' },

  // Jaeger-LeCoultre
  { brand: 'Jaeger-LeCoultre', model: 'Reverso Classic', reference: 'Q3858520' },
  { brand: 'Jaeger-LeCoultre', model: 'Master Ultra Thin', reference: 'Q1338421' },
  { brand: 'Jaeger-LeCoultre', model: 'Polaris Chronograph', reference: 'Q9028480' },

  // Hublot
  { brand: 'Hublot', model: 'Big Bang', reference: '301.SX.1170.RX' },
  { brand: 'Hublot', model: 'Classic Fusion', reference: '542.NX.1171.RX' },
  { brand: 'Hublot', model: 'Spirit of Big Bang', reference: '641.NX.0173.LR' },

  // Panerai
  { brand: 'Panerai', model: 'Luminor Marina', reference: 'PAM01312' },
  { brand: 'Panerai', model: 'Submersible', reference: 'PAM01305' },
  { brand: 'Panerai', model: 'Luminor Due', reference: 'PAM01249' },

  // Tudor
  { brand: 'Tudor', model: 'Black Bay 58', reference: 'M79030N' },
  { brand: 'Tudor', model: 'Black Bay', reference: 'M7941A1A0RU' },
  { brand: 'Tudor', model: 'Pelagos', reference: 'M25600TN' },
  { brand: 'Tudor', model: 'Black Bay GMT', reference: 'M79830RB' },
  { brand: 'Tudor', model: 'Black Bay Chrono', reference: 'M79360N' },

  // Vacheron Constantin
  { brand: 'Vacheron Constantin', model: 'Overseas', reference: '4500V' },
  { brand: 'Vacheron Constantin', model: 'Patrimony', reference: '85180' },
  { brand: 'Vacheron Constantin', model: 'Historiques', reference: '1110S' },

  // A. Lange & Söhne
  { brand: 'A. Lange & Söhne', model: 'Lange 1', reference: '191.032' },
  { brand: 'A. Lange & Söhne', model: 'Saxonia', reference: '380.032' },
  { brand: 'A. Lange & Söhne', model: 'Odysseus', reference: '363.068' },

  // Richard Mille
  { brand: 'Richard Mille', model: 'RM 011', reference: 'RM011-03' },
  { brand: 'Richard Mille', model: 'RM 035', reference: 'RM035-02' },
  { brand: 'Richard Mille', model: 'RM 067', reference: 'RM067-01' },

  // Zenith
  { brand: 'Zenith', model: 'Chronomaster Sport', reference: '03.3100.3600' },
  { brand: 'Zenith', model: 'Defy Skyline', reference: '03.9300.3620' },
  { brand: 'Zenith', model: 'Pilot Type 20', reference: '29.2430.679' },

  // Blancpain
  { brand: 'Blancpain', model: 'Fifty Fathoms', reference: '5015-1130-52A' },
  { brand: 'Blancpain', model: 'Villeret', reference: '6654-3642-55B' },

  // Others
  { brand: 'Chopard', model: 'Alpine Eagle', reference: '298600-3001' },
  { brand: 'Chopard', model: 'Happy Sport' },
  { brand: 'Bulgari', model: 'Octo Finissimo' },
  { brand: 'Bulgari', model: 'Serpenti' },
  { brand: 'Hermès', model: 'Arceau' },
  { brand: 'Hermès', model: 'H08' },
  { brand: 'Piaget', model: 'Polo Date' },
  { brand: 'Breguet', model: 'Marine', reference: '5517BB' },
  { brand: 'Breguet', model: 'Classique', reference: '5177BB' },
  { brand: 'Longines', model: 'Spirit' },
  { brand: 'Longines', model: 'HydroConquest' },
  { brand: 'Longines', model: 'Master Collection' },
  { brand: 'Grand Seiko', model: 'Spring Drive', reference: 'SBGA211' },
  { brand: 'Grand Seiko', model: 'Heritage Collection', reference: 'SBGX261' },
  { brand: 'Nomos', model: 'Tangente', reference: '164' },
  { brand: 'Nomos', model: 'Club Campus', reference: '736' },
  { brand: 'Oris', model: 'Aquis Date', reference: '01 733 7730 4157' },
  { brand: 'Oris', model: 'Big Crown ProPilot' },
  { brand: 'Bell & Ross', model: 'BR 03-92', reference: 'BR0392-D-BL-ST' },
  { brand: 'Bell & Ross', model: 'BR 05', reference: 'BR05A-BL-ST' },
  { brand: 'Franck Muller', model: 'Vanguard' },
  { brand: 'Franck Muller', model: 'Cintrée Curvex' },
  { brand: 'Jacob & Co', model: 'Astronomia' },
  { brand: 'Jacob & Co', model: 'Epic X Chrono' },
];

export function searchWatchModels(query: string): WatchModel[] {
  if (!query || query.length < 2) return [];
  const q = query.toLowerCase();
  return WATCH_MODELS.filter(
    (w) =>
      w.brand.toLowerCase().includes(q) ||
      w.model.toLowerCase().includes(q) ||
      (w.reference && w.reference.toLowerCase().includes(q)) ||
      `${w.brand} ${w.model}`.toLowerCase().includes(q)
  ).slice(0, 10);
}
